



















































import {Component, Mixins, Prop} from 'vue-property-decorator';
import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
import {Location} from "vue-router"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsPaginator extends Mixins(TextProviderMixin) {
    @Prop() value!: string;
    @Prop() pages!: string;
    @Prop({default: 'pages'}) name!: string;

    @Prop() route!: ((page: number) => Location)|''|true|undefined;

    @Prop({default: 'full'}) mode!: 'full' | 'arrows';

    get currentPage() {
        return Math.min(Math.max(parseInt(this.value ?? 1), 1), this.maxPage);
    }

    get maxPage() {
        return Number.isNaN(Number(this.pages)) ? 1 : Math.max(Number(this.pages), 1);
    }

    get list() {
        if (this.maxPage <= 7) {
            return [...Array(this.maxPage).keys()].map(i => i + 1);
        }
        let target = Math.max(Math.min(this.maxPage - 3, this.currentPage), 4);
        return [1,
            target > 4 ? null : target - 2,
            target - 1,
            target,
            target + 1,
            target < this.maxPage - 3 ? null : target + 2,
            this.maxPage];
    }

    get shouldUseDefaultRouting() {
        return this.route === '' || this.route === true;
    }

    changePage(target: number) {
        if (this.route === undefined) {
            this.$emit('input', Math.min(Math.max(target, 1), this.maxPage));
        }
    }

    getRoute(page: number): Location|null {
        if (this.route === undefined) {
            return null;
        }
        if (this.shouldUseDefaultRouting) {
            return {...this.$route, query: {...this.$route.query, page: page + ''}} as Location;
        }
        if (typeof this.route === 'function') {
            return this.route(page);
        }
        return null;
    }

    getLabel (page: number, current: number) {
        if (page === current) {
            return this.$text('jds.components.paginator.current_page', {page: page + ''});
        } else {
            return this.$text('jds.components.paginator.go_to_page', {page: page + ''});
        }
    }
}
